/* # =================================================================
#現在のbreakpointをbodyタグに記述
# ================================================================= */

export default function currentBreakpoint() {
	const width = window.innerWidth;
	let breakpoint;

	if (width >= 1800) {
		breakpoint = 'xxxxl';
	} else if (width >= 1500) {
		breakpoint = 'xxxl';
	} else if (width >= 1400) {
		breakpoint = 'xxl';
	} else if (width >= 1200) {
		breakpoint = 'xl';
	} else if (width >= 992) {
		breakpoint = 'lg';
	} else if (width >= 768) {
		breakpoint = 'md';
	} else if (width >= 576) {
		breakpoint = 'sm';
	} else {
		breakpoint = 'xs';
	}

	document.body.setAttribute('data-breakpoint', breakpoint);
}
